import { ActionType, ActionWidget, SPI, ValidatorStatus, ViewActionTarget, Widget } from '@kunlun/dependencies';
import { formTableImportV2 } from '../formTableImportV2/formTableImportV2';
import { queryWorkbook } from '../../../api';

@SPI.ClassFactory(
  ActionWidget.Token({
    widget: 'FormTableImportV2',
    model: 'deli.aries.settlement.DeliAriesCmActivityItem',
    name: 'uiViewdcd6d9e78fd84865a4ecd49df1b31ffa',
    actionType: [ActionType.View],
    target: [ViewActionTarget.Dialog, ViewActionTarget.Router, ViewActionTarget.Inner]
  })
)
export class CustomFormTableImportV2 extends formTableImportV2 {
  @Widget.Reactive()
  get importErrorMsg() {
    if (this.errorArr.length) {
      return '导入失败' + (this.errorArr.length ? '，部分数据错误' : '');
    }
    return '导入成功';
  }

  protected getImportRootData() {
    if (this.rootData![0]) {
      const selectedWorkbook = this.workbookList.find((w) => w.id === this.selectValue);
      return { ...this.rootData![0], templateName: selectedWorkbook.displayName };
    }

    return {};
  }

  protected fillDatasource(data: any[]) {
    if (this.errorArr.length > 0) {
      return;
    }

    const selectedWorkbook = this.workbookList.find((w) => w.id === this.selectValue);

    if (selectedWorkbook.displayName === '在卖门店数更新模板') {
      data.forEach((d) => {
        const { outCode } = d;
        const item = this.dataSource?.find((i) => i.outCode === outCode);
        if (item) {
          item.sellingStoreCount = d.sellingStoreCount;
        }
      });
    } else if (selectedWorkbook.displayName === '即将下架时间更新模板') {
      data.forEach((d) => {
        const { outCode } = d;
        const item = this.dataSource?.find((i) => i.outCode === outCode);
        if (item) {
          item.autoOffShelfTime = d.autoOffShelfTime;
        }
      });
    } else {
      super.fillDatasource(data);
    }
  }

  protected async openDialog(val) {
    const importTemplateName = this.getConfig('importTemplateName') as string;
    this.validation1 = {
      status: ValidatorStatus.Success,
      help: ''
    };
    this.validation2 = { status: ValidatorStatus.Success, help: '' };
    this.selectValue = '';
    if (this.firstOpen && val) {
      this.firstOpen = false;
      const templateNames = importTemplateName
        .split(',')
        .map((n) => n.trim())
        .filter(Boolean);
      const allWorkbooks: any[] = [];
      for (const name of templateNames) {
        const result = await queryWorkbook(this.model, false, name);
        allWorkbooks.push(...result.content);
      }
      this.workbookList = allWorkbooks;
    }
    if (this.workbookList && this.workbookList.length > 0) {
      this.selectValue = this.workbookList[0].id;
    }

    this.generateHeader();
    this.visible = val;
  }

  @Widget.Reactive()
  protected handleSelectChange(val) {
    this.selectValue = val;
    this.generateHeader();
  }

  protected generateHeader() {
    const selectedWorkbook = this.workbookList.find((w) => w.id === this.selectValue);
    if (!selectedWorkbook) return;
    const sheetDefinitions = JSON.parse(selectedWorkbook.sheetDefinitions);
    const enFieldsArr = sheetDefinitions[0].blockDefinitionList[0].headerList[0].cellList;
    const enFieldsKeyArr = enFieldsArr.map((enField) => enField.field);
    const cnFieldsArr = sheetDefinitions[0].blockDefinitionList[0].headerList[1].cellList;
    this.headerFieldsArrMap = {
      enFieldsArr,
      enFieldsKeyArr,
      cnFieldsArr
    };
    const headerFields: any[] = [];
    enFieldsKeyArr.forEach((i, index) => {
      this.copyModleFields.forEach((j) => {
        if (j.name === i) {
          // @ts-ignore
          j.excelLabel = cnFieldsArr[index].value;
          headerFields.push(j);
        }
      });
    });

    this.headerFields = headerFields;
  }
}
